module.exports = __webpack_public_path__ + "media/newstyle/images/responsabilidade-109c0ffb10d3cfc66d1df403f259d8e0.png";